export const reload = {
  baseProduct: (base_product_id) => {
    const params = new URLSearchParams(location.search);
    if (base_product_id) params.set('bp_id', base_product_id);
    params.delete('pc_id');
    window.location.search = `?${params.toString()}`;
  },
};
